<template>
  <a
    class="state-layer-neutral flex items-center justify-between rounded-sm border border-main bg-surface-elevation-1 p-3 text-main"
    :href="url"
    target="_blank"
    data-testid="page-download-card"
  >
    <div>
      <h3 class="txt-body-m-bold">{{ title }}</h3>
      <p class="txt-body-s text-subtle">{{ description }}</p>
    </div>
    <div class="flex shrink-0 cursor-pointer items-center justify-center p-2 text-main">
      <SvgIcon :path="mdiTrayArrowDown" :size="24" class="" />
    </div>
  </a>
</template>
<script lang="ts" setup>
import { mdiTrayArrowDown } from '@mdi/js'

import SvgIcon from '@/components/SvgIcon.vue'

defineProps<{
  title: string
  description?: string
  url: string
}>()
</script>
